export type GallerySize = "sm" | "tall" | "wide" | "lg";

export interface GalleryFrame {
  id: string;
  src: string;
  alt: string;
  caption?: string;
  size: GallerySize;
}

const BASE = "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media";

export const GALLERY_FRAMES: GalleryFrame[] = [
  {
    id: "f1",
    src: `${BASE}/6a960f8fe68555d6d5f721ce.jpg`,
    alt: "Ieshia Danielle speaking with women at a live event",
    size: "lg",
  },
  {
    id: "f2",
    src: `${BASE}/6a960f853f5a7cedaaf9d319.jpg`,
    alt: "Ieshia Danielle connecting with attendees after a session",
    size: "tall",
  },
  {
    id: "f3",
    src: `${BASE}/6a960f7e276f28ee539962c2.jpg`,
    alt: "Women gathered together at an Ieshia Danielle workshop",
    size: "sm",
  },
  {
    id: "f4",
    src: `${BASE}/6a960eed02832ae86181f708.jpg`,
    alt: "Ieshia Danielle teaching on stage during the Becoming Intensive",
    size: "wide",
  },
  {
    id: "f5",
    src: `${BASE}/6a960ee3648f56e7e43cd490.jpg`,
    alt: "A moment of reflection at an Ieshia Danielle event",
    size: "sm",
  },
  {
    id: "f6",
    src: `${BASE}/6a960e543f5a7cedaaf9c179.jpg`,
    alt: "Ieshia Danielle in conversation with a guest",
    size: "tall",
  },
  {
    id: "f7",
    src: `${BASE}/6a960e549ced56098adc8088.jpg`,
    alt: "Women sharing their stories in the Between Me & You room",
    size: "lg",
  },
  {
    id: "f8",
    src: `${BASE}/6a960e5402832ae86181eeba.jpg`,
    alt: "Ieshia Danielle praying with a group of women",
    size: "sm",
  },
  {
    id: "f9",
    src: `${BASE}/6a95dfe9648f56e7e438aefa.jpg`,
    alt: "A full room at an Ieshia Danielle live event",
    size: "wide",
  },
  {
    id: "f10",
    src: `${BASE}/6a95dfe93f5a7cedaaf5b238.jpg`,
    alt: "Ieshia Danielle smiling with event attendees",
    size: "sm",
  },
  {
    id: "f11",
    src: `${BASE}/6a95dfe6648f56e7e438ae98.jpg`,
    alt: "Ieshia Danielle leading a workshop session",
    size: "lg",
  },
  {
    id: "f12",
    src: `${BASE}/6a95dfe8d931dc0751475c5a.jpg`,
    alt: "Women embracing after a breakthrough moment",
    size: "tall",
  },
  {
    id: "f13",
    src: `${BASE}/6a95dfe5f22eac14d9c04ee4.jpg`,
    alt: "Ieshia Danielle greeting guests at an event",
    size: "sm",
  },
  {
    id: "f14",
    src: `${BASE}/6a95dfe59ced56098ad84fe3.jpg`,
    alt: "The Between Me & You podcast set with guests",
    size: "wide",
  },
  {
    id: "f15",
    src: `${BASE}/6a95dfe7f22eac14d9c04f30.jpg`,
    alt: "A candid moment between Ieshia Danielle and an attendee",
    size: "sm",
  },
  {
    id: "f16",
    src: `${BASE}/6a95dfe5e68555d6d5f2d5d7.jpg`,
    alt: "Ieshia Danielle captured mid-teaching",
    size: "tall",
  },
  {
    id: "f17",
    src: `${BASE}/6a95dfe6276f28ee53953ce0.jpg`,
    alt: "Women worshipping together at a live gathering",
    size: "lg",
  },
  {
    id: "f18",
    src: `${BASE}/6a95dfe3d931dc0751475bc5.jpg`,
    alt: "Ieshia Danielle with a guest on the podcast",
    size: "sm",
  },
  {
    id: "f19",
    src: `${BASE}/6a95dfe370fc5d91f5b5dfc6.jpg`,
    alt: "Attendees writing through the From Burnout to Becoming workbook",
    size: "wide",
  },
  {
    id: "f20",
    src: `${BASE}/6a95dfe29ced56098ad84f43.jpg`,
    alt: "Ieshia Danielle laughing with women at an event",
    size: "sm",
  },
  {
    id: "f21",
    src: `${BASE}/6a95dfe22abe62a97cf7d227.jpg`,
    alt: "A group photo from an Ieshia Danielle intensive weekend",
    size: "lg",
  },
  {
    id: "f22",
    src: `${BASE}/6a95dfe2276f28ee53953c7c.jpg`,
    alt: "Ieshia Danielle in the podcast studio",
    size: "tall",
  },
  {
    id: "f23",
    src: `${BASE}/6a95dfe19ced56098ad84f19.jpg`,
    alt: "Women gathered around a table sharing their journeys",
    size: "sm",
  },
  {
    id: "f24",
    src: `${BASE}/6a95dfde276f28ee53953c02.jpg`,
    alt: "Ieshia Danielle speaking from the stage to a full room",
    size: "wide",
  },
  {
    id: "f25",
    src: `${BASE}/6a95dfe170fc5d91f5b5df88.jpg`,
    alt: "A quiet moment of prayer at an event",
    size: "sm",
  },
  {
    id: "f26",
    src: `${BASE}/6a95dfde70fc5d91f5b5df16.jpg`,
    alt: "Ieshia Danielle photographed at a speaking engagement",
    size: "tall",
  },
  {
    id: "f27",
    src: `${BASE}/6a95dfde9ced56098ad84e82.jpg`,
    alt: "Women celebrating together after a workshop",
    size: "lg",
  },
  {
    id: "f28",
    src: `${BASE}/6a95dfde9ced56098ad84e79.jpg`,
    alt: "Ieshia Danielle with a guest speaker",
    size: "sm",
  },
  {
    id: "f29",
    src: `${BASE}/6a95dfdef22eac14d9c04dfa.jpg`,
    alt: "The Becoming Intensive cohort gathered together",
    size: "wide",
  },
  {
    id: "f30",
    src: `${BASE}/6a95dfdef22eac14d9c04dfe.jpg`,
    alt: "Ieshia Danielle closing out a live event",
    size: "sm",
  },
];
